import React, { useContext, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { FormContext } from "../../context/FormContext"; // Importar el contexto
import ConfirmacionReservaPopup from "../ConfirmacionReservaPopup";

const PopupFormAtencionCliente = ({numeroCita, numeroCliente, onClose}) => {
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
        watch,
      } = useForm();
    const { formData, updateFormData } = useContext(FormContext); // Usar el contexto
    const [flag, setFlag] = useState(false);
    const [profesiones, setProfesiones] = useState([]);

    
    useEffect(() => {
        const fetchDataProfesiones = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL_PROFESIONES}`,{
                    method: "GET"
                });
                if (response.status === 200) {
                    const data = await response.json();
                    if (data.data) {
                        setProfesiones(data.data);
                    }else {
                        // Error en la estructura de respuesta de profesiones
                        console.error("Error en la respuesta de profesiones:", data);
                        setProfesiones([]);
                    }
                }
            } catch (error) {
                // Error al obtener profesiones desde la API
                console.error("Error obteniendo Profesiones:", error);
                setProfesiones([]);
            }
        }
        fetchDataProfesiones();
    }, []);

    const onSubmit = async (data) => {
        // Lógica para manejar los datos del formulario
        // Datos del formulario de anamnesis enviados por el usuario
        // console.log("Data del Formulario: ",data);
        const datosCliente = {
            operacion: "1",
            accion: "1",
            enc_codigo: "2",
            int_codigo: numeroCliente,
            det_codigo: JSON.stringify({"30":{"alt_codigo": data.dispositivo > 0 ? 21: 22,"mtr_codigo": data.frecuencia}
                        ,"31":{"alt_codigo": data.montura > 0 ? 23: 24,"mtr_codigo": data.tiempo1}
                        ,"32":{"alt_codigo": data.lentesContacto > 0 ? 25: 26,"mtr_codigo": data.tiempo2}
                        ,"33":{"alt_codigo": data.ojos > 0 ? 27: 28,"mtr_codigo":0}
                        ,"34":{"alt_codigo": data.picor > 0 ? 29: 30,"mtr_codigo":0}
                        ,"35":{"alt_codigo": data.resequedad > 0 ? 31: 32,"mtr_codigo":0}
                        ,"36":{"alt_codigo": data.dolor > 0 ? 33: 34,"mtr_codigo":0}
                        ,"37":{"alt_codigo": data.molestia > 0 ? 35: 36,"mtr_codigo":0}
                        ,"38":{"alt_codigo": data.secrecion > 0 ? 37: 38,"mtr_codigo":0}}),
            prf_codigo: data.profesion,
            ana_actividad: data.actividades
        }
        // Datos procesados del cliente para envío a la API
        // console.log("Datos del cliente: ", datosCliente);
        const queryParams = new URLSearchParams(datosCliente).toString();
        const url = `${process.env.REACT_APP_API_URL_ATENCION_CLIENTE}?${queryParams}`;

        try {
            const response = await fetch(url, {
                method: 'POST',
            });

            const result = await response.json();
            // Respuesta recibida desde la API de atención al cliente
            // console.log("Respuesta de la API:", result);

            if (result.success && result.proceso) {
                // Anamnesis registrada exitosamente
                // console.log("Anamnesis registrada correctamente");
                setFlag(true); // Mostrar Confirmación
            } else {
                // Error: anamnesis no se registró correctamente
                // console.log("Anamnesis no se registro correctamente");
                // alert("Hubo un problema al registrar la anamnesis");
                setFlag(true); // Mostrar Confirmación
            }
        } catch (error) {
            // Error al enviar datos de anamnesis a la API
            console.error("Error al enviar datos a la API:", error);
            // alert("Error de conexión con el servidor");
        }
        // setFlag(true);
      };
  return (
    <div>
      <div
        className="modal fade show"
        style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        tabIndex="-1"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          style={{ maxWidth: "700px" }}
        >
          <div className="modal-content modal-succes">
            <div className="modal-body body-cita-confirmada">
                <form onSubmit={handleSubmit(onSubmit)} className="form-add-patient">
                    <div className="row">
                        <div className="col-12 text-center mb20">
                            <h3>
                            Por favor ayúdenos respondiendo estas preguntas para una mejor atención
                            </h3>
                        </div>
                        {/* Columna para los input */}
                        <div className="col-6">
                            {/* Primera columna */}
                            <div className="mb-2 mt-2">
                                <label className="form-label" htmlFor="profesion">Ocupación o Profesíon</label>
                                <select className="form-control" id="profesion" {...register("profesion")}>
                                    <option value="0" disabled selected>- Seleccione -</option>
                                    {profesiones.map((profesion) => (
                                        <option key={profesion.prf_codigo} value={profesion.prf_codigo}>
                                            {profesion.prf_denominacion}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="row">
                                <div className="col-lg-6 col-sm-12">
                                    <div className="mb-2 mt-2">
                                        <label className="form-label">Uso dispositivos electrónicos</label>
                                        <label htmlFor="dispositivo1" className="form-label m-lg-1">
                                            <input type="radio" className="form-check-input" id="dispositivo1" {...register("dispositivo")} value="1"/>
                                            {" "}
                                            SI
                                        </label>
                                        <label htmlFor="dispositivo2" className="form-label m-lg-1">
                                            <input type="radio" className="form-check-input" id="dispositivo2" {...register("dispositivo")} value="0"/>
                                            {" "}
                                            NO
                                        </label>
                                    </div>
                                    <div className="mb-2 mt-2">
                                        <label className="form-label">Usuario de monturas óptica</label>
                                        <label htmlFor="montura1" className="form-label m-lg-1">
                                            <input type="radio" className="form-check-input" id="montura1" {...register("montura")} value="1"/>
                                            {" "}
                                            SI
                                        </label>
                                        <label htmlFor="montura2" className="form-label m-lg-1">
                                            <input type="radio" className="form-check-input" id="montura2" {...register("montura")} value="0"/>
                                            {" "}
                                            NO
                                        </label>
                                    </div>
                                    <div className="mb-2 mt-2">
                                        <label className="form-label">Usuario de lentes de contacto</label>
                                        <label htmlFor="lentesContacto1" className="form-label m-lg-1">
                                            <input type="radio" className="form-check-input" id="lentesContacto1" {...register("lentesContacto")} value="1"/>
                                            {" "}
                                            SI
                                        </label>
                                        <label htmlFor="lentesContacto2" className="form-label m-lg-1">
                                            <input type="radio" className="form-check-input" id="lentesContacto2" {...register("lentesContacto")} value="0"/>
                                            {" "}
                                            NO
                                        </label>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-12">
                                    <div className="mb-2 mt-2">
                                        <label className="form-label" htmlFor="frecuencia">Frecuencias(Horas)</label>
                                        <select className="form-control" id="frecuencia" {...register("frecuencia")} disabled={watch("dispositivo") !== "1"}>
                                            <option value="0" disabled selected>- Seleccione -</option>
                                            <option value="1">De 0 a 2</option>
                                            <option value="2">De 2 a 4</option>
                                            <option value="3">De 4 a 8</option>
                                            <option value="4">Mas de 8</option>
                                        </select>
                                    </div>
                                    <div className="mb-2 mt-2">
                                        <label className="form-label" htmlFor="tiempo1">Tiempo de uso (años)</label>
                                        <select className="form-control" id="tiempo1" {...register("tiempo1")} disabled={watch("montura") !== "1"}>
                                            <option value="0" disabled selected>- Seleccione -</option>
                                            <option value="1">De 0 a 2</option>
                                            <option value="2">De 2 a 4</option>
                                            <option value="3">De 4 a 8</option>
                                            <option value="4">Mas de 8</option>
                                        </select>
                                    </div>
                                    <div className="mb-2 mt-2">
                                        <label className="form-label" htmlFor="tiempo2">Tiempo de uso (años)</label>
                                        <select className="form-control" id="tiempo2" {...register("tiempo2")} disabled={watch("lentesContacto") !== "1"}>
                                            <option value="0" disabled selected>- Seleccione -</option>
                                            <option value="1">De 0 a 2</option>
                                            <option value="2">De 2 a 4</option>
                                            <option value="3">De 4 a 8</option>
                                            <option value="4">Mas de 8</option>
                                        </select>
                                    </div>
                                </div>
                            </div>  
                        </div>
                        <div className="col-6">
                            {/* segunda columna */}
                            <div className="mb-2 mt-2">
                                <label htmlFor="actividades" className="form-label">Otras actividades</label>
                                <input type="text" className="form-control" id="actividades" {...register("actividades")}/>
                            </div>
                            <div className="row">
                                <div className="col-lg-6 col-sm-12">
                                    <div className="mb-lg-4 mb-sm-2 mt-2">
                                        <label className="form-label">Ojos rojos</label><br />
                                        <label htmlFor="ojos1" className="form-label m-lg-1">
                                            <input type="radio" className="form-check-input" id="ojos1" {...register("ojos")} value="1"/>
                                            {" "}
                                            SI
                                        </label>
                                        <label htmlFor="ojos2" className="form-label m-lg-1">
                                            <input type="radio" className="form-check-input" id="ojos2" {...register("ojos")} value="0"/>
                                            {" "}
                                            NO
                                        </label>
                                    </div>
                                    <div className="mb-lg-4 mb-sm-2 mt-2">
                                        <label className="form-label">Picor u ardor ocular</label>
                                        <label htmlFor="picor1" className="form-label m-lg-1">
                                            <input type="radio" className="form-check-input" id="picor1" {...register("picor")} value="1"/>
                                            {" "}
                                            SI
                                        </label>
                                        <label htmlFor="picor2" className="form-label m-lg-1">
                                            <input type="radio" className="form-check-input" id="picor2" {...register("picor")} value="0"/>
                                            {" "}
                                            NO
                                        </label>
                                    </div>
                                    <div className="mb-2 mt-2">
                                        <label className="form-label">Resequedad</label><br />
                                        <label htmlFor="resequedad1" className="form-label m-lg-1">
                                            <input type="radio" className="form-check-input" id="resequedad1" {...register("resequedad")} value="1"/>
                                            {" "}
                                            SI
                                        </label>
                                        <label htmlFor="resequedad2" className="form-label m-lg-1">
                                            <input type="radio" className="form-check-input" id="resequedad2" {...register("resequedad")} value="0"/>
                                            {" "}
                                            NO
                                        </label>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-12">
                                    <div className="mb-lg-3 mb-sm-2 mt-2">
                                        <label className="form-label">Dolor de cabeza al leer</label>
                                        <label htmlFor="dolor1" className="form-label m-lg-1">
                                            <input type="radio" className="form-check-input" id="dolor1" {...register("dolor")} value="1"/>
                                            {" "}
                                            SI
                                        </label>
                                        <label htmlFor="dolor2" className="form-label m-lg-1">
                                            <input type="radio" className="form-check-input" id="dolor2" {...register("dolor")} value="0"/>
                                            {" "}
                                            NO
                                        </label>
                                    </div>
                                    <div className="mb-2 mt-2">
                                        <label className="form-label">Molestia uso de computadora</label>
                                        <label htmlFor="molestia1" className="form-label m-lg-1">
                                            <input type="radio" className="form-check-input" id="molestia1" {...register("molestia")} value="1"/>
                                            {" "}
                                            SI
                                        </label>
                                        <label htmlFor="molestia2" className="form-label m-lg-1">
                                            <input type="radio" className="form-check-input" id="molestia2" {...register("molestia")} value="0"/>
                                            {" "}
                                            NO
                                        </label>
                                    </div>
                                    <div className="mb-2 mt-2">
                                        <label className="form-label">Secreción</label><br />
                                        <label htmlFor="secrecion1" className="form-label m-lg-1">
                                            <input type="radio" className="form-check-input" id="secrecion1" {...register("secrecion")} value="1"/>
                                            {" "}
                                            SI
                                        </label>
                                        <label htmlFor="secrecion2" className="form-label m-lg-1">
                                            <input type="radio" className="form-check-input" id="secrecion2" {...register("secrecion")} value="0"/>
                                            {" "}
                                            NO
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>   
                        <div className="col-12 text-center mt-4">
                            <input
                            type="submit"
                            className="step-patient-button gmo-theme-button"
                            value={"CONTINUAR"}
                            style={{padding: "3px 55px 3px 55px"}}
                            />
                        </div>                 
                    </div>
                </form>
            </div>
          </div>
        </div>
      </div>
      {flag && (
        <ConfirmacionReservaPopup
            numeroCita={numeroCita}
            onClose={true}
        />
      )}
    </div>
  );
};

export default PopupFormAtencionCliente;